import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Watch, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import CountDown from '@/components/countdown/index.vue';
import { dateTimeFormatter as _dateTimeFormatter, readCookie } from '@/tools/tools';
import { refundingList, refundList, getDataRefund, getRefundSearch } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.editableTabsValue = '0';
    _this.editableTabs = [{
      title: '处理中',
      name: '0',
      content: 'Tab 1 content'
    }, {
      title: '申请记录',
      name: '1',
      content: 'Tab 2 content'
    }];
    _this.options = [{
      value: '1',
      label: '最近一个月'
    }, {
      value: '2',
      label: '最近三个月'
    }, {
      value: '3',
      label: '三个月以前'
    }];
    _this.statusOptions = [{
      value: '',
      label: '全部状态'
    }, {
      value: '1',
      label: '处理中'
    }, {
      value: '2',
      label: '已完成'
    }, {
      value: '3',
      label: '已取消'
    }, {
      value: '4',
      label: '申请失败'
    }];
    _this.value = '1';
    _this.statusValue = '';
    _this.orderList = []; // 订单列表
    // page: number = 1
    _this.status = '';
    // 当前页数
    _this.currentpage = 1;
    // 有无数据
    _this.isNodata = false;
    // 总条数
    _this.totalnumber = 10;
    _this.pageNo = 1;
    _this.pageSize = 10;
    _this.docmHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //  是否固定底部
    _this.isFixed = false;
    _this.loading = false;
    // 关键字查询
    _this.keyword = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "activated",
    value: function activated() {
      this.getOrderList();
    }
    // mounted() {
    //   const menuHeight = (this as any).$refs.menucont.offsetHeight;
    //   this.isFixed = menuHeight < this.docmHeight - 200;
    // }
  }, {
    key: "onTimeChange",
    value: function onTimeChange() {
      this.getOrderList();
    }
  }, {
    key: "onStatusChange",
    value: function onStatusChange() {
      this.getOrderList();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.currentpage = 1;
      this.orderList = [];
      this.getOrderList();
    }
    // 订单列表
  }, {
    key: "getOrderList",
    value: function () {
      var _getOrderList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var anchor, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              this.orderList = [];
              url = this.editableTabsValue === '0' ? refundingList : refundList;
              this.loading = true;
              _context.next = 6;
              return url({
                timeRange: this.value,
                status: this.statusValue,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                keyword: this.keyword,
                companyId: 1
              });
            case 6:
              res = _context.sent;
              if (res.data.code === 100) {
                if (this.editableTabsValue === '1') {
                  this.orderList = [].concat(_toConsumableArray(this.orderList), _toConsumableArray(res.data.data.list));
                  this.orderList.forEach(function (ele, key, arr) {
                    if (arr[key].applyType === 3) {
                      if (arr[key].status === 2) {
                        _this2.$set(arr[key], 'statusStr', '申请失败');
                      } else if (arr[key].status === 6) {
                        _this2.$set(arr[key], 'statusStr', '已完成');
                      } else if (arr[key].status === 7) {
                        _this2.$set(arr[key], 'statusStr', '已取消');
                      } else {
                        _this2.$set(arr[key], 'statusStr', '处理中');
                      }
                    } else if (arr[key].status === 2) {
                      _this2.$set(arr[key], 'statusStr', '申请失败');
                    } else if (arr[key].status === 3) {
                      _this2.$set(arr[key], 'statusStr', '已完成');
                    } else if (arr[key].status === 7) {
                      _this2.$set(arr[key], 'statusStr', '已取消');
                    } else {
                      _this2.$set(arr[key], 'statusStr', '处理中');
                    }
                  });
                } else {
                  getDataRefund({
                    refundingNum: res.data.data.total,
                    equip: anchor ? anchor.equip : 4,
                    version: anchor ? anchor.version : '',
                    src: anchor ? anchor.src ? anchor.src : 2 : 4,
                    model: anchor ? anchor.model : '',
                    equipVersion: anchor ? anchor.equipVersion : '',
                    equipMeid: anchor ? anchor.equipMeid : '',
                    eventNo: '3.2.2.2.0.0.1',
                    companyId: 1
                  });
                  this.orderList = res.data.data.list;
                }
                this.totalnumber = res.data.data.total;
                this.isNodata = this.orderList.length === 0;
              } else {
                this.$message.error(res.data.message);
              }
              this.loading = false;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOrderList() {
        return _getOrderList.apply(this, arguments);
      }
      return getOrderList;
    }() // 去付款
  }, {
    key: "goPay",
    value: function () {
      var _goPay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$router.push("/payment?id=".concat(id));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function goPay(_x) {
        return _goPay.apply(this, arguments);
      }
      return goPay;
    }()
  }, {
    key: "goRecord",
    value: function goRecord() {
      this.$router.push('/exchange-list?status=0');
    }
  }, {
    key: "search",
    value: function search() {
      var anchor = readCookie('anchor');
      this.pageSize = 10;
      this.pageNo = 1;
      getRefundSearch({
        refundingNum: '',
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: '3.2.2.1.0.0.1',
        companyId: 1
      });
      this.getOrderList();
    }
  }, {
    key: "applydetails",
    value: function applydetails(id) {
      this.$router.push("/exchange-details?id=".concat(id));
    }
    // 订单详情
  }, {
    key: "goOrderDetails",
    value: function goOrderDetails(id) {
      this.$router.push("/order-details?id=".concat(id));
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getOrderList();
      window.scrollTo(0, 0);
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getOrderList();
      window.scrollTo(0, 0);
    }
  }]);
}(Vue);
__decorate([Watch('value')], default_1.prototype, "onTimeChange", null);
__decorate([Watch('statusValue')], default_1.prototype, "onStatusChange", null);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    CountDown: CountDown,
    NavMenu: NavMenu
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    }
  }
})], default_1);
export default default_1;